import React, {useEffect, useState} from 'react';
import LoginModal from "../login/LoginModal";
import FooterDefault from "../footer/common-footer";
import Header from "./Header";
import MobileMenu from "../header/MobileMenu";
import axios from "axios";
import Main1 from "../accueil/main1";
import Main2 from "../accueil/main2";
import Libre1 from "../accueil/libre1";
import Seo from "../common/Seo";
import FormModel from "../form/FormModel";
import Libre2 from "../accueil/libre2";
import Ressources from "../../pages/boursorama/Ressources";
import { motion } from 'framer-motion';

const Home7 = () => {
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [homeData, setHomeData] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const loadTimeout = setTimeout(() => {
            setIsPageLoaded(true);
        }, 1000);

        return () => clearTimeout(loadTimeout);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setIsPageLoaded(true);
            try {
                const response = await axios.get(process.env.REACT_APP_API_BASE_URL + `/front_pages?type=1`);
                setHomeData(response.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            } finally {
                setIsPageLoaded(false);
            }
        };

        fetchData();
    }, []);

    return (
            <>
                {/* Login modal blocks until password is correct */}
                <LoginModal
                    isOpen={!isLoggedIn}
                    onSuccess={() => setIsLoggedIn(true)}
                    clientPassword={"gth-boursorama"}
                    pageToken={"boursorama"}
                />

                {isLoggedIn && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ ease: 'easeInOut', duration: 0.5 }}>
                    <Seo
                        pageTitle='Hotline Talents Handicap'
                        pageDescription="Hotline Talents Handicap"
                        pageUrl={window.location.href}
                        imageUrl="/images/hotline-TH%201.png"
                    />

                    <span className="header-span"></span>

                    <Header secondLogo={true}/>

                    <MobileMenu secondLogo={true}/>

                    <Libre1/>

                    <Main2/>

                    <Main1/>

                    <Libre2/>

                    {/*todo:boursorama*/}
                    {/*<Ressources/>*/}

                    <section className="contact-section layout-pb-50 layout-pt-50">
                    {/*todo:boursorama*/}
                    {/*<section className="contact-section contact-section-alternate layout-pb-50 layout-pt-50">*/}
                        <div className="auto-container">
                            <div className="text-center">
                                <h2 className="libre-title">
                                    Nous contacter <span>en cas de besoin !</span>
                                </h2>

                                <div className="text mt-15">
                                    Pour toute question, une demande d’aide ou une difficulté pour réserver un rendez-vous,
                                    contactez-nous ! Nous vous répondrons dans les meilleurs délais.
                                    Vos messages seront traités par l’équipe Talents Handicap de manière totalement
                                    anonyme.
                                </div>
                            </div>
                            <div className="d-flex justify-content-center w-100">
                                <div className="contact-form default-form">
                                    <FormModel/>
                                </div>
                            </div>
                            <div className="text text-center mt-3">
                                Ou si vous le préférez, appelez-nous directement au numéro suivant: <span>+33 (0) 7 84 72 04 01</span><br/>(Accessible du 14 au 21 novembre 2024 du lundi au vendredi de 09h00 à 12h00 et de 14h00 à 17h00)
                            </div>
                        </div>
                    </section>

                    {isPageLoaded && (
                        <FooterDefault footerStyle="style-six alternate -type-11"/>
                        // <FooterDefault footerStyle=""/> todo:boursorama
                    )}
                    </motion.div>
                )}
            </>
    );
};

export default Home7;
